
import { toast } from 'react-toastify';
import axiosInstance from '../../../../../axiosInstance';
import { getDomain, getEmployeeId, getUserData, getUserId } from '../../../Base/helper/baseFunctions';
import { HRMS_LMS_API_URL } from '../../../../Constants/baseConstant';



export const AddMyTimeSheetHelper = async (params) => {
    var data = getUserData();
    toast.info("Loading...")
    return await axiosInstance(`/lms/addMytimeSheet`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            user_id: data.emp_users_pk,
            from_date_day: params?.from_date_day,
            from_date_month: params?.from_date_month,
            from_date_year: params?.from_date_year,
            to_date_day: params?.to_date_day,
            to_date_month: params?.to_date_month,
            to_date_year: params?.to_date_year,
            week_no: params?.week_no,
            weekly_working_days:params?.weekly_working_days,
            manager_emp_id:params?.manager_emp_id,
            mytime_configure_id: params?.mytime_configure_id || null
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success(`MyTimeSheet Submitted successfully`);
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateMyTimeSheetHelper = async (params) => {
    var data = getUserData();
    toast.info("Loading...")
    return await axiosInstance(`/lms/updateMytimeSheet`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            user_id: data.emp_users_pk,
            from_date_day: params?.from_date_day,
            from_date_month: params?.from_date_month,
            from_date_year: params?.from_date_year,
            to_date_day: params?.to_date_day,
            to_date_month: params?.to_date_month,
            to_date_year: params?.to_date_year,
            week_no: params?.week_no,
            weekly_working_days:params?.weekly_working_days,
            manager_emp_id:params?.manager_emp_id,
            mytime_configure_id: params?.mytime_configure_id || null
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success(`MyTimeSheet Updated successfully`);
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetMyTimeSheetHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/getMytimeSheet`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            user_id: data?.emp_users_pk, 
            from_date_day: params?.from_date_day,
            from_date_month: params?.from_date_month,
            from_date_year: params?.from_date_year,
            to_date_day: params?.to_date_day,
            to_date_month: params?.to_date_month,
            to_date_year: params?.to_date_year,
            from_add: false,
            emp_user_id: params?.my_time_flag ? null : getUserId(),
            approval_screen: params?.approval_screen || false
        }
    })
        .then((res) => {
            toast.dismiss();
            res?.data?.data?.length === 0 && toast.warning("No Records Found")
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}


export const GetMyTimeSheetLeaveInfoHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/getMytimeSheetLeaveInfo`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data?.domain,
            user_id: data?.emp_users_pk,
            emp_id: data?.employee_id,
            from_date_day: params?.from_date_day,
            from_date_month: params?.from_date_month,
            from_date_year: params?.from_date_year,
            to_date_day: params?.to_date_day,
            to_date_month: params?.to_date_month,
            to_date_year: params?.to_date_year,
            mytime_configure_id:params?.mytime_configure_id || null
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}


export const GetMyTimeSheetProjectHelper = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/getMytimeProject`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetMyTimeSheetInfo = async (params) => {
    var data = getUserData();
    return await axiosInstance(`/lms/getMytimeSheetInfo`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: data.domain,
            employee_id: data?.employee_id
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetWeekdaysHelper = async (params) => {
    return await axiosInstance(`/lms/getweekday`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            start_date_day: params?.start_date_day,
            start_date_month: params?.start_date_month,
            start_date_year: params?.start_date_year,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetWeekdatesHelper = async (params) => {
    return await axiosInstance(`/lms/getweekdates`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            start_date_day: params?.start_date_day,
            start_date_month: params?.start_date_month,
            start_date_year: params?.start_date_year,
            to_date_day: params?.end_date_day,
            to_date_month: params?.end_date_month,
            to_date_year: params?.end_date_year,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetMyAttendancePermissionHelper = async (params) => {
    return await axiosInstance(`/lms/permission/getMyAttendancePermission`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            emp_user_id: getUserId(),
            month: params.month,
            year: params.year,
            tab: params?.tab // 'Team' or 'Self'
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpsertMyAttendancePermissionHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    const successMessage = params?.actionType === "add" ? "Permission added successfully" : "Permission updated successfully" 
    return await axiosInstance(`/lms/permission/upsertMyAttendancePermission`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            employee_fk: params?.employee_fk,
            month: params.month,
            year: params.year,
            record_date: params.record_date,
            daily_hours: params.daily_hours,
            user_id: getUserId(),
            status: params?.status
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success(successMessage);
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Error");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const DeleteMyAttendancePermissionHelper = async (params) => {
    toast.info("Deleting...");
    return await axiosInstance(`/lms/permission/deleteMyAttendancePermission`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            employee_permission_mapping_pk: params?.employee_permission_mapping_pk,
            month: params.month,
            year: params.year,
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Successfully deleted");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Error");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const GetApproverEmpPermissionMappingHelper = async (params) => {
    return await axiosInstance(`/lms/permission/getApproverEmpPermissionMapping`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            emp_user_id: getUserId(),
            month: params?.month || null,
            year: params?.year || null,
        }
    })
        .then((res) => {
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

export const UpdateApproverEmpPermissionMappingHelper = async (params) => {
    toast.dismiss();
    toast.info("Saving...");
    return await axiosInstance(`/lms/permission/updateApproverEmpPermissionMapping`, {
        method: "POST",
        baseURL: HRMS_LMS_API_URL,
        data: {
            domain_name: getDomain(),
            employee_permission_mapping_pk: params.employee_permission_mapping_pk,
            status: params.status, // Approved / Rejected
            user_id: getUserId(),
            emp_user_id: getUserId(),
            comment: params?.comment || null
        }
    })
        .then((res) => {
            toast.dismiss();
            toast.success("Permission updated successfully");
            return { message: "Success", hasError: false, data: res?.data }
        }).catch(err => {
            toast.dismiss();
            toast.error(err?.response?.data?.error?.[0]?.message || "Error");
            return { message: "Error", hasError: true, data: err?.response?.data }
        })
}

